import { trpc } from '@/shared/api';

export const usePortfoliosQuery = (input: { page: number; categoryId?: string }) =>
  trpc.portfolioManagement.items.list.useQuery(input);
